import clothesWasher from "../../../../assets/image/most-efficient/clothes-washer.png";
import Refrigerators from "../../../../assets/image/most-efficient/refrigerators.png";
import Dishwashers from "../../../../assets/image/most-efficient/dishwashers.png";
import Dryers from "../../../../assets/image/most-efficient/dryers.png";
import airConditioner from "../../../../assets/image/most-efficient/air-conditioner.png";
import dehumidifiers from "../../../../assets/image/most-efficient/dehumidifiers.png";
import heatingCooling from "../../../../assets/image/most-efficient/heating-cooling.png";
import ventFan from "../../../../assets/image/most-efficient/vent-fan.png";
import ceilingFan from "../../../../assets/image/most-efficient/ceiling-fan.png";
import monitor from "../../../../assets/image/most-efficient/monitor.png";
import window from "../../../../assets/image/most-efficient/window.png";
import airCleaner from "../../../../assets/image/most-efficient/air-cleaner.png";

interface Product {
  title: string;
  image: string;
  altText: string;
  singleLink?: {
    text: string;
    url: string;
    ariaLabel: string;
  };
  links?: Array<{
    text: string;
    url: string;
    ariaLabel: string;
  }>;
}

const productData: Product[] = [
  {
    title: "Clothes Washer",
    image: clothesWasher,
    altText: "Clothes washer",
    singleLink: {
      text: "Clothes Washer",
      url: "/most-efficient/me-certified-clothes-washers/results?is_most_efficient_filter=Most+Efficient",
      ariaLabel: "Learn more about Clothes Washers",
    },
  },
  {
    title: "Refrigerators & Freezers",
    image: Refrigerators,
    altText: "Refrigerators & Freezers",
    links: [
      {
        text: "Standard Refrigerators",
        url: "/most-efficient/me-certified-refrigerators/results?type_filter=Side-by-Side&is_most_efficient_filter=Most+Efficient",
        ariaLabel: "Learn more about Refrigerators & Freezers",
      },

      {
        text: "Compact Refrigerators",
        url: "/most-efficient/me-certified-refrigerators/results?type_filter=Compact&is_most_efficient_filter=Most+Efficient",
        ariaLabel: "Learn more about Compact Refrigerators",
      },
      {
        text: "Standard Freezers",
        url: "/most-efficient/me-certified-freezers/results?type_filter=Upright+Freezer&is_most_efficient_filter=Most+Efficient",
        ariaLabel: "Learn more about Standard Freezers",
      },
      {
        text: "Compact Freezers",
        url: "/most-efficient/me-certified-freezers/results?type_filter=Compact&is_most_efficient_filter=Most+Efficient",
        ariaLabel: "Learn more about Compact Freezers",
      },
    ],
  },
  {
    title: "Dishwashers",
    image: Dishwashers,
    altText: "Dishwashers",
    singleLink: {
      text: "Dishwashers",
      url: "/most-efficient/me-certified-dishwashers/results?is_most_efficient_filter=Most+Efficient",
      ariaLabel: "Learn more about Dishwashers",
    },
  },
  {
    title: "Dryers",
    image: Dryers,
    altText: "Dryers",
    singleLink: {
      text: "Dryers",
      url: "/most-efficient/me-certified-clothes-dryers/results?is_most_efficient_filter=Most+Efficient",
      ariaLabel: "Learn more about Dryers",
    },
  },
  {
    title: "Room Air Conditioners​",
    image: airConditioner,
    altText: "Room Air Conditioners​",
    singleLink: {
      text: "Room Air Conditioners​",
      url: "/most-efficient/me-certified-room-ac/results?is_most_efficient_filter=Most+Efficient",
      ariaLabel: "Learn more about Room Air Conditioners",
    },
  },
  {
    title: "Dehumidifiers",
    image: dehumidifiers,
    altText: "Dehumidifiers",
    singleLink: {
      text: "Dehumidifiers",
      url: "/most-efficient/me-certified-dehumidifiers/results?is_most_efficient_filter=Most+Efficient",
      ariaLabel: "Learn more about Dehumidifiers",
    },
  },
  {
    title: "Heating & Cooling",
    image: heatingCooling,
    altText: "Heating & Cooling",
    links: [
      {
        text: "Heat Pumps",
        url: "/most-efficient/me-certified-heat-pumps/results?is_most_efficient_filter=Most+Efficient",
        ariaLabel: "Learn more about Heating & Cooling",
      },
      {
        text: "Geothermal Heat Pumps",
        url: "/most-efficient/me-certified-geothermal-heat-pumps/results?is_most_efficient_filter=Most+Efficient",
        ariaLabel: "Learn more about Geothermal Heat Pumps",
      },
    ],
  },
  {
    title: "Ventilating Fans",
    image: ventFan,
    altText: "Ventilating Fans",
    singleLink: {
      text: "Ventilating Fans",
      url: "/most-efficient/me-certified-ventilating-fans/results?is_most_efficient_filter=Most+Efficient",
      ariaLabel: "Learn more about Ventilating Fans",
    },
  },
  {
    title: "Ceiling Fans",
    image: ceilingFan,
    altText: "Ceiling Fans",
    singleLink: {
      text: "Ceiling Fans",
      url: "/most-efficient/me-certified-ceiling-fans/results?is_most_efficient_filter=Most+Efficient",
      ariaLabel: "Learn more about Ceiling Fans",
    },
  },
  {
    title: "Computer Monitors",
    image: monitor,
    altText: "Computer Monitors",
    singleLink: {
      text: "Computer Monitors",
      url: "/most-efficient/me-certified-computer-monitors/results?is_most_efficient_filter=Most+Efficient",
      ariaLabel: "Learn more about Computer Monitors",
    },
  },
  {
    title:
      "Windows, Sliding Glass Doors, Skylights, & Tubular Daylighting Devices",
    image: window,
    altText:
      "Windows, Sliding Glass Doors, Skylights, & Tubular Daylighting Devices",
    singleLink: {
      text: "Windows, Sliding Glass Doors, Skylights, & Tubular Daylighting Devices",
      url: "/most-efficient/me-certified-windows/results?is_most_efficient_filter=Most%20Efficient",
      ariaLabel:
        "Learn more about Windows, Sliding Glass Doors, Skylights, & Tubular Daylighting Devices",
    },
  },
  {
    title: "Room Air Cleaners",
    image: airCleaner,
    altText: "Room Air Cleaners",
    singleLink: {
      text: "Room Air Cleaners",
      url: "/most-efficient/me-certified-room-air-cleaners/results?is_most_efficient_filter=Most+Efficient",
      ariaLabel: "Learn more about Room Air Cleaners",
    },
  },
];

export default productData;
